<div class="calendar-heading">
  {{ 'calendar.heading' | translate}}
</div>

<div class="calendar-container">
  <div class="">
    <div class="row mt-5 mt-md-0 g-0">
      <div class="col-12 col-md-6">
        <div class="label-padding">
          <div class="calendar-label">
            {{ 'calendar.month' | translate }}
          </div>
          <div class="dropdown-container">
            <libero-dropdown
              [availableList]="availableMonths"
              (itemSelected)="valueUpdated($event, 'month')"
              [displaySelectAllOption]="false"
              [initialValue]="availableMonths[selectedMonth]"
              [itemSelectedControl]="selectedMonthControl"
            ></libero-dropdown>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mt-4 mt-md-0">
        <div class="label-padding">
          <div class="calendar-label">
            {{ 'calendar.year' | translate}}
          </div>
          <div class="dropdown-container">
            <libero-dropdown
              [availableList]="availableYears"
              (itemSelected)="valueUpdated($event, 'year')"
              [displaySelectAllOption]="false"
              [initialValue]="availableYears[0]"
              [itemSelectedControl]="selectedYearControl"
            ></libero-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (apiError) {
    <div class="api-error-container"  data-cy="calendar-api-error-container">
      {{ 'global.error.loadData' | translate }}
    </div>
  } @else if (preloader) {
    <div class="preload-container">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else {
    <div class="dropdown-navigation" data-cy="calendar-content-container">
      <div
        class="arrow-container"
        (click)="setPrev('month')"
        (keydown.space)="setPrev('month')"
        (keydown.enter)="!arrowDisabled('month', slideDirections.PREV) && setPrev('month')"
        tabindex="0"
        [ngClass]="{'arrow-container--disabled': arrowDisabled('month', slideDirections.PREV)}"
        >
        <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'height.px':26 }"></svg-icon>
      </div>
      <libero-calendar [calendarData]="selectedCalendarData"></libero-calendar>
      <div
        class="arrow-container"
        [ngClass]="{'arrow-container--disabled': arrowDisabled('month', slideDirections.NEXT)}"
        (click)="setNext('month')"
        (keydown.space)="!arrowDisabled('month', slideDirections.NEXT) && setNext('month')"
        (keydown.enter)="!arrowDisabled('month', slideDirections.NEXT) && setNext('month')"
        tabindex="0"
        >
        <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'height.px':26, 'transform': 'rotate(180deg)' }"></svg-icon>
      </div>
    </div>
  }
</div>
